import React from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import IconComponent from "../button/IconComponent"; // Ensure you have this component

const SubMenuComponent = ({ authorizationSubMenuList }) => {
  const handleClickAction = () => {
    alert("Page Under Development")
  };
  return (
    <div className="grid grid-cols-12 gap-6 mt-5">
      {authorizationSubMenuList &&
        authorizationSubMenuList.map((item, index) => (
          item.url && item.url.includes("/") ?
            <div
              key={index}
              className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
            >
              <div className="report-box zoom-in">
                <Link to={item.url}>
                  <div className="box p-5">
                    <div className="flex">
                      <IconComponent icon={item.icon} height={32} color="green" />
                      <div className="ml-auto">
                        <div
                          className="report-box__indicator bg-theme-9 tooltip cursor-pointer"
                          title="33% Higher than last month"
                        >
                          {item.count}
                          <FeatherIcon
                            icon="chevron-up"
                            className="w-4 h-4 ml-0.5"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-base text-gray-600 mt-1">{item.name}</div>
                  </div>
                </Link>
              </div>
            </div>
            :
            <div
              key={index}
              className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
            >
              <div className="report-box zoom-in">
                  <div className="box p-5" onClick={handleClickAction}>
                    <div className="flex">
                      <IconComponent icon={item.icon} height={32} color="green" />
                      <div className="ml-auto">
                        <div
                          className="report-box__indicator bg-theme-9 tooltip cursor-pointer"
                          title="33% Higher than last month"
                        >
                          {item.count}
                          <FeatherIcon
                            icon="chevron-up"
                            className="w-4 h-4 ml-0.5"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-base text-gray-600 mt-1">{item.name}</div>
                  </div>
              </div>
            </div>
        ))}
    </div>
  );
};
SubMenuComponent.propTypes = {
  authorizationSubMenuList: PropTypes.array.isRequired,
};
export default SubMenuComponent;
